import React, { Component } from 'react';

import Widget from "./Widget";

class WidgetRow extends Component {

    getStatusColor(value) {
        if (value === 1) {
            return "red"
        }
        return "green"
    }

    render() {
        return (
            <div className="dashboard-widget-row">
                <div className="dashboard-widget-row-header" onClick={() => {navigator.clipboard.writeText("B62qpYngyqVnBCs92WoPCYQxLs4arKnBSppBr1rHtshmtWY19hVdJd3")}}>
                    <span style={{color:"#bbbbbb"}}>chain: </span>{this.props.row.accountId ? this.props.row.accountId.split(".")[0] : "Account ID Unset"}&nbsp;<span style={{color:"#bbbbbb"}}>&nbsp;&nbsp;network: </span>{this.props.row.environment}
                    &nbsp;<span style={{color:"#bbbbbb"}}>&nbsp;&nbsp;status:</span> <span style={{color: this.getStatusColor(this.props.row.syncing)}}>{!this.props.row.syncing ? "SYNCED" : "SYNCING"}</span>
                </div>
                {
                    this.props.row.widgets.map((widget, widgetIndex) => {
                        if (widget) {
                            return <Widget
                               key={widgetIndex}
                               value={widget.value}
                               title={widget.title}
                               subtitle={widget.subtitle}
                               subtitle2={widget.subtitle2}
                               updated={widget.updated}
                               meter={widget.meter}
                               background={widget.background}
                               displayValue={widget.displayValue}
                               greenThreshold={widget.greenThreshold}
                               yellowThreshold={widget.yellowThreshold}
                            />
                        }
                        else {
                            return <Widget
                                key={widgetIndex}
                                value={""}
                                title={""}
                                subtitle={""}
                                subtitle2={""}
                                updated={""}
                                meter={""}
                                background={""}
                                displayValue={""}
                                greenThreshold={0}
                                yellowThreshold={0}
                            />
                        }
                    })
                }

            </div>
        );
    }
}

export default WidgetRow;
